export default __webpack_public_path__ + "static/media/2244.fa058411.jpg";